import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import {isMobileOnly} from 'react-device-detect';

const BrFilterTopItemListBlock = styled.div`
    margin-bottom: 0px;
    border-bottom: 2px solid #111;
    position: relative;

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const BrFilterTopItemUlBlock = styled.ul`
    float: left;
    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const BrFilterTopItemLiBlock = styled.li`
    float: left;
    padding: 20px 25px;

    :first-child {
        padding-left: ${isMobileOnly?'10px':'20px'};
    }
`;

const BrFilterTopItemBtnBlock = styled.button`
    position: relative;
    z-index: 1;
    font-size: 18px;
    font-weight: ${props => props.weight};
    color : ${props => props.color};

    ::after {
        content: "";
        display: ${props => props.display};
        position: absolute;
        bottom: 3px;
        left: 0;
        width: 100%;
        height: 4px;
        background-color: #79b88a;
        z-index: -1;
      }
`;

const BrFilterTopRightFilterMagrinBlock = styled.div`
    padding-top: 21px;
    margin-top: 20px;
    float: right;
`;

const BrFilterTopRightFilterSelectContainerBlock = styled.div`
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
    width:110px;
`;


const Options = [
    { value: 0, label: "최신순" },
    { value: 1, label: "인기순" }
];

const BrFilterTopItemList = ({ onClick, curTabFirst }) => {
    const [curFilterOrderIndex, setCurFilterOrderIndex] = useState(0);


    const handleTagClick = () => {
        onClick(true);
    }
    const handleTagClick2 = () => {
        onClick(false);
    }

    const onChangeOrder = (param) => {
        // console.log("onChangeOrder : " + JSON.stringify(param));
        // console.log("onChangeOrder : " + param.value);
        setCurFilterOrderIndex(param.value)

    }


    return (
        <BrFilterTopItemListBlock>
            <BrFilterTopItemUlBlock>
                <BrFilterTopItemLiBlock>
                    <BrFilterTopItemBtnBlock onClick={handleTagClick} display={curTabFirst ? 'block' : 'none'}
                        weight={curTabFirst ? '700' : ''} color={curTabFirst ? '#000000' : '#999999'}>
                        브랜드
                    </BrFilterTopItemBtnBlock>
                </BrFilterTopItemLiBlock>
                <BrFilterTopItemLiBlock>
                    <BrFilterTopItemBtnBlock onClick={handleTagClick2} display={curTabFirst ? 'none' : 'block'}
                        weight={curTabFirst ? '' : '700'} color={curTabFirst ? '#999999' : '#00000'}>
                        내가 찾는 브랜드가 없다면?
                    </BrFilterTopItemBtnBlock>
                </BrFilterTopItemLiBlock>
            </BrFilterTopItemUlBlock>
            <BrFilterTopRightFilterMagrinBlock>
            </BrFilterTopRightFilterMagrinBlock>

        </BrFilterTopItemListBlock>
    );

};

export default BrFilterTopItemList;
